import _ from 'lodash'
import { useState } from 'react'
import { habitTypeMap } from '../utils/constants'
import { Target, makeHabitsFromTargetsAndScores } from '../utils/dataFormatting'
import { Dialog } from './Dialog'
import EditTargetDialog from './EditTargetDialog'
import HabitsPanel from './HabitsPanel'
import { NewHabitType } from './TargetScores'
import TipCarousel from './TipCarousel'

export type TargetChangeHandler = (targets: Target[]) => Promise<void>

interface EditTargetsDialogProps {
  isOpen: boolean
  initialTargets: Target[]
  onChangeTargets: TargetChangeHandler
  onClose: () => void
}

type NewTarget = Omit<Target, 'id'>

const EditTargetsDialog = ({
  isOpen,
  initialTargets,
  onChangeTargets,
  onClose,
}: EditTargetsDialogProps) => {
  const [targets, setTargets] = useState<Target[]>(initialTargets)
  const [selectedHabitType, setSelectedHabitType] =
    useState<NewHabitType | null>(null)

  const handleTargetChange = async (newTarget: NewTarget) => {
    const [changedTargets, otherTargets] = _.partition(
      targets,
      (t) => t.habitType === newTarget.habitType
    )
    setTargets([...otherTargets, { ...changedTargets[0], ...newTarget }])
    setSelectedHabitType(null)
  }

  return (
    <Dialog
      isOpen={isOpen}
      title={`🎯 Edit your targets!`}
      text=""
      hasSubmitButton={true}
      onSubmit={() => onChangeTargets(targets)}
      submitText="Done!"
      isSubmitDisabled={_.isEqual(initialTargets, targets)}
      closeText="Back"
      onClose={onClose}
    >
      <TipCarousel />
      <HabitsPanel
        habits={makeHabitsFromTargetsAndScores(targets, [])}
        targets={targets}
        onClickHabit={async (habit) =>
          setSelectedHabitType(habitTypeMap[habit.name])
        }
        isInEditMode={true}
      />
      <p style={{ textAlign: 'center' }}>Tap on a habit to adjust the target</p>
      {selectedHabitType && (
        <EditTargetDialog
          isOpen={!_.isNil(selectedHabitType)}
          targetBeingEdited={
            targets.find((t) => t.habitType === selectedHabitType) as Target
          }
          onSubmit={handleTargetChange}
          onCancel={() => setSelectedHabitType(null)}
        />
      )}
    </Dialog>
  )
}

export default EditTargetsDialog
